import type { OrdersState, State } from 'types';

export default {
  getOrders: (state: State): OrdersState => state.orders,
  getProp:
    <T extends keyof OrdersState>(propKey: T) =>
    (state: State) =>
      state.orders[propKey],
};
